{
  "pagination": {
    "ListQueues": {
      "result_key": "QueueUrls"
    }
  }
}